export function NumberUp() {
  const NUMBER = document.querySelector('.box-experience p')

  if (NUMBER) {
    const START = Number(NUMBER.textContent.replace('+', ''))
    let NEW_NUMBER = Math.ceil(START / 2)

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const interval = setInterval(() => {
            if (NEW_NUMBER !== START) {
              NEW_NUMBER++
              NUMBER.textContent = NEW_NUMBER.toString() + '+'
            } else {
              clearInterval(interval)
            }
          }, 3)
          observer.unobserve(entry.target)
        }
      })
    })

    observer.observe(NUMBER)
  }
}
